export class ImportFile {
    public Text: string;
    public Title: string;
    public MimeType: string;
    public RestID: string;
}                                            